/**
 * Asynchronously loads the component for MarketTrendPage
 */

import { lazyLoad } from "@utils/loadable";

export const MarketTrendPage = lazyLoad(
  () => import("./index"),
  (module) => module.MarketTrendPage
);
